/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
const PagesInitialState = {
    lastPage: '/inicio',
};
const PagesSlicer = createSlice({
    name: 'page',
    initialState: PagesInitialState,
    reducers: {
        setPage: (state, { payload: { page } }) => {
            state.lastPage = page;
        },
    },
});
export const { setPage } = PagesSlicer.actions;
export default PagesSlicer.reducer;
